import React from "react";
import { Box } from "@mui/material";
import { useMyLeaveAdminBadges } from "my-leave/hooks";
import { OcSidebarBadge } from "oc/components/sidebar-badge";

export const MyLeaveMenuAdminBadges = () => {
  const { data } = useMyLeaveAdminBadges();
  if (!data) return null;

  return (
    <Box display="flex" flexDirection="row" alignItems="center">
      <OcSidebarBadge value={data} urgent id="myLeaveAdminMenuBadge" />
    </Box>
  );
};
